import React, { useCallback } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {
  Search as SearchIcon,
  Clear as ClearIcon,
} from "@material-ui/icons";
import { usePdvStyles } from "../styles/pdvStyles";
import clsx from "clsx";

const LargeTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: 14,
    padding: "10px 14px",
    maxWidth: 300,
    backgroundColor: theme.palette.grey[800],
  },
  arrow: {
    color: theme.palette.grey[800],
  },
}))(Tooltip);

const PdvSearchBar = ({
  value,
  onChange,
  onClear,
  onFocus,
  onBlur,
  inputRef,
  isActive = false,
  isSearching = false,
  placeholder = "Buscar Produtos",
  autoFocus = false,
}) => {
  const classes = usePdvStyles();

  const handleChange = useCallback(
    (event) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handleClear = useCallback(() => {
    onClear();
    inputRef?.current?.focus();
  }, [onClear, inputRef]);

  const handleKeyDown = useCallback(
    (event) => {
      // Prevent default behavior for specific keys
      if (event.key === "Escape") {
        handleClear();
        event.preventDefault();
      }
    },
    [handleClear]
  );

  return (
    <div className={classes.searchContainer}>
      <LargeTooltip title="Pesquisa por Código de Barras, Descrição ou Fórmula" arrow>
        <TextField
          inputRef={inputRef}
          fullWidth
          variant="outlined"
          size="small"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={handleKeyDown}
          autoFocus={autoFocus}
          className={clsx(classes.searchInput, {
            [classes.searchInputActive]: isActive,
          })}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {isSearching ? (
                  <CircularProgress size={20} />
                ) : (
                  <SearchIcon color="action" />
                )}
              </InputAdornment>
            ),
            endAdornment: value && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={handleClear}
                  edge="end"
                  title="Limpar busca"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </LargeTooltip>
    </div>
  );
};

export default React.memo(PdvSearchBar);
